<template>
  <div class="page-wrapper bg-light">
    <vue-easy-lightbox
      :visible="lightboxVisible"
      :imgs="lightboxImgs"
      :index="lightboxIndex"
      @hide="onHideLightbox"
    ></vue-easy-lightbox>

    <div class="content container-fluid">
      <div class="page-header mb-4">
        <div class="row align-items-center justify-content-between">
          <div class="col-md-5 mb-3 mb-md-0">
            <h3 class="page-title text-dark font-weight-bold mb-1">
              Lịch Sử Phản Ánh & Kiến Nghị
            </h3>
            <ul class="breadcrumb bg-transparent p-0 m-0">
              <li class="breadcrumb-item">
                <router-link to="/" class="text-muted text-decoration-none"
                  >Dashboard</router-link
                >
              </li>
              <li class="breadcrumb-item active">Của tôi</li>
            </ul>
          </div>

          <div
            class="col-md-7 d-flex flex-wrap justify-content-md-end align-items-center"
          >
            <button
              class="btn btn-white shadow-sm mr-2 font-weight-medium"
              @click="showFilterModal = true"
            >
              <i class="fa fa-filter text-primary mr-1"></i> Tìm kiếm & Lọc
              <span v-if="isFiltering" class="badge badge-primary ml-1">!</span>
            </button>

            <div class="btn-group shadow-sm mr-2 bg-white rounded">
              <button
                type="button"
                class="btn btn-view"
                :class="{ active: viewMode === 'grid' }"
                @click="viewMode = 'grid'"
                title="Dạng lưới"
              >
                <i class="fa fa-th-large"></i>
              </button>
              <button
                type="button"
                class="btn btn-view"
                :class="{ active: viewMode === 'list' }"
                @click="viewMode = 'list'"
                title="Dạng danh sách"
              >
                <i class="fa fa-list"></i>
              </button>
            </div>

            <router-link
              to="/gop-y-kien-nghi/tao-moi"
              class="btn btn-primary btn-add shadow-sm"
            >
              <i class="fa fa-plus-circle mr-2"></i>Tạo mới
            </router-link>
          </div>
        </div>
      </div>

      <div
        v-if="showFilterModal"
        class="custom-modal-backdrop"
        @click.self="showFilterModal = false"
      >
        <div
          class="custom-modal-dialog animate-pop-in"
          style="max-width: 500px"
        >
          <div class="modal-content border-0">
            <div class="modal-header border-bottom-0 pb-0">
              <h5 class="modal-title font-weight-bold">Tìm kiếm & Sắp xếp</h5>
              <button
                type="button"
                class="close-btn"
                @click="showFilterModal = false"
              >
                <i class="fa fa-times"></i>
              </button>
            </div>
            <div class="modal-body p-4">
              <div class="form-group mb-3">
                <label class="font-weight-bold small text-muted">Từ khóa</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-light border-0"
                      ><i class="fa fa-search"></i
                    ></span>
                  </div>
                  <input
                    type="text"
                    class="form-control bg-light border-0"
                    placeholder="Nhập tiêu đề hoặc nội dung..."
                    v-model="filters.keyword"
                  />
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 form-group mb-3">
                  <label class="font-weight-bold small text-muted"
                    >Trạng thái</label
                  >
                  <select
                    class="form-control custom-select bg-light border-0"
                    v-model="filters.status"
                  >
                    <option value="">Tất cả</option>
                    <option value="MOI_GUI">Mới gửi</option>
                    <!-- <option value="DA_XEM">Đã xem</option> -->
                    <option value="DANG_XU_LY">Đang xử lý</option>
                    <option value="DA_GIAI_QUYET">Đã giải quyết</option>
                    <option value="TU_CHOI">Từ chối</option>
                  </select>
                </div>
                <div class="col-md-6 form-group mb-3">
                  <label class="font-weight-bold small text-muted"
                    >Danh mục</label
                  >
                  <select
                    class="form-control custom-select bg-light border-0"
                    v-model="filters.categoryId"
                  >
                    <option :value="null">Tất cả</option>
                    <option
                      v-for="cat in listCategories"
                      :key="cat.id"
                      :value="cat.id"
                    >
                      {{ cat.tenDanhMuc }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="form-group mb-4">
                <label class="font-weight-bold small text-muted"
                  >Sắp xếp theo</label
                >
                <select
                  class="form-control custom-select bg-light border-0"
                  v-model="filters.sort"
                >
                  <option value="ngayTao,desc">Mới nhất trước</option>
                  <option value="ngayTao,asc">Cũ nhất trước</option>
                </select>
              </div>

              <div class="d-flex">
                <button
                  class="btn btn-light flex-grow-1 mr-2"
                  @click="resetFilters"
                >
                  <i class="fa fa-undo mr-1"></i> Đặt lại
                </button>
                <button
                  class="btn btn-primary flex-grow-1"
                  @click="applyFilters"
                >
                  Áp dụng tìm kiếm
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="isLoading" class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>

      <div
        v-else-if="listBaoCao.length === 0"
        class="text-center py-5 empty-state"
      >
        <div class="empty-icon-wrapper mb-3">
          <i class="fa fa-folder-open-o"></i>
        </div>
        <h4 class="text-dark font-weight-bold">
          Chưa có phản ánh và kiến nghị nào
        </h4>
        <p class="text-muted">
          Mọi đóng góp của bạn đều giúp công ty phát triển tốt hơn.
        </p>
        <router-link
          to="/gop-y-kien-nghi/tao-moi"
          class="btn btn-outline-primary mt-2"
        >
          Gửi phản ánh & kiến nghị ngay
        </router-link>
      </div>

      <div v-else>
        <transition name="fade" mode="out-in">
          <div v-if="viewMode === 'grid'" key="grid" class="row">
            <div
              class="col-md-6 col-lg-4 mb-4 d-flex align-items-stretch"
              v-for="item in listBaoCao"
              :key="item.id"
            >
              <div
                class="card modern-card w-100 border-0 h-100"
                @click="openDetail(item)"
              >
                <div class="card-body p-4 d-flex flex-column">
                  <div
                    class="d-flex justify-content-between align-items-start mb-3"
                  >
                    <span class="category-tag">
                      {{ item.tenDanhMuc }}
                    </span>
                    <span
                      class="status-dot"
                      :class="getStatusColorClass(item.trangThai)"
                      :title="getStatusLabel(item.trangThai)"
                    ></span>
                  </div>

                  <h5
                    class="card-title font-weight-bold text-dark mb-2 text-truncate-2"
                    :title="item.tieuDe"
                  >
                    {{ item.tieuDe }}
                  </h5>

                  <p
                    class="card-text text-muted small text-truncate-3 mb-3 flex-grow-1"
                  >
                    {{ item.noiDung }}
                  </p>

                  <div
                    v-if="item.danhSachAnh && item.danhSachAnh.length > 0"
                    class="img-preview-grid mb-3"
                  >
                    <div
                      v-for="(img, idx) in item.danhSachAnh.slice(0, 3)"
                      :key="idx"
                      class="img-thumb"
                    >
                      <img :src="img" />
                    </div>
                    <div v-if="item.danhSachAnh.length > 3" class="img-more">
                      +{{ item.danhSachAnh.length - 3 }}
                    </div>
                  </div>

                  <div
                    class="d-flex justify-content-between align-items-center mt-auto pt-3 border-top"
                  >
                    <div class="d-flex align-items-center">
                      <div class="avatar-circle mr-2">
                        <i class="fa fa-user"></i>
                      </div>
                      <div class="d-flex flex-column">
                        <span class="font-size-xs font-weight-bold text-dark">
                          {{
                            item.tenNguoiGui === "Người dùng ẩn danh"
                              ? "Ẩn danh"
                              : "Tôi"
                          }}
                        </span>
                        <span class="font-size-xs text-muted">{{
                          formatDate(item.ngayTao)
                        }}</span>
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                      <button
                        v-if="item.trangThai === 'MOI_GUI'"
                        class="btn btn-xs btn-outline-danger mr-2 font-weight-bold border-0 bg-soft-danger"
                        @click.stop="handleRevoke(item)"
                        title="Thu hồi"
                      >
                        <i class="fa fa-undo"></i>
                      </button>
                      <div
                        :class="['badge-pill', getStatusClass(item.trangThai)]"
                      >
                        {{ getStatusLabel(item.trangThai) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-else key="list" class="list-layout">
            <div class="card border-0 shadow-sm rounded-lg overflow-hidden">
              <div class="list-group list-group-flush">
                <div
                  v-for="item in listBaoCao"
                  :key="item.id"
                  class="list-group-item list-group-item-action p-4 d-flex flex-column flex-md-row align-items-md-center justify-content-between cursor-pointer"
                  @click="openDetail(item)"
                >
                  <div
                    class="d-flex align-items-center mb-3 mb-md-0 flex-grow-1"
                    style="min-width: 0"
                  >
                    <div
                      class="list-icon-shape mr-3"
                      :class="getStatusColorClass(item.trangThai, true)"
                    >
                      <i class="fa fa-file-text-o"></i>
                    </div>
                    <div class="list-content" style="min-width: 0">
                      <div class="d-flex align-items-center mb-1">
                        <h6
                          class="font-weight-bold text-dark mb-0 text-truncate mr-2"
                        >
                          {{ item.tieuDe }}
                        </h6>
                        <span
                          class="badge badge-light border text-muted small"
                          >{{ item.tenDanhMuc }}</span
                        >
                      </div>
                      <p class="text-muted small mb-0 text-truncate">
                        {{ item.noiDung }}
                      </p>
                      <div class="d-md-none mt-2">
                        <span
                          :class="[
                            'badge-pill-sm',
                            getStatusClass(item.trangThai),
                          ]"
                        >
                          {{ getStatusLabel(item.trangThai) }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div
                    class="d-flex align-items-center justify-content-between list-meta ml-md-4"
                  >
                    <div class="text-right mr-4 d-none d-md-block">
                      <div class="text-dark font-weight-medium font-size-sm">
                        {{ formatDate(item.ngayTao) }}
                      </div>
                      <div class="text-muted font-size-xs">Ngày gửi</div>
                    </div>
                    <div
                      class="d-none d-md-block"
                      style="min-width: 100px; text-align: right"
                    >
                      <button
                        v-if="item.trangThai === 'MOI_GUI'"
                        class="btn btn-sm text-danger font-weight-bold mr-3 btn-hover-danger"
                        @click.stop="handleRevoke(item)"
                      >
                        <i class="fa fa-undo mr-1"></i> Thu hồi
                      </button>
                      <span
                        :class="['badge-pill', getStatusClass(item.trangThai)]"
                      >
                        {{ getStatusLabel(item.trangThai) }}
                      </span>
                    </div>
                    <i
                      class="fa fa-chevron-right text-muted ml-3 ml-md-4 font-size-sm"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <div v-if="totalPages > 1" class="row mt-4">
        <div class="col-md-12 d-flex justify-content-center">
          <nav aria-label="Page navigation">
            <ul class="pagination pagination-rounded">
              <li class="page-item" :class="{ disabled: currentPage === 0 }">
                <a
                  class="page-link"
                  href="#"
                  @click.prevent="changePage(currentPage - 1)"
                >
                  <i class="fa fa-angle-left"></i>
                </a>
              </li>

              <li
                class="page-item"
                v-for="page in visiblePages"
                :key="page"
                :class="{
                  active: currentPage === page - 1,
                  disabled: page === '...',
                }"
              >
                <a
                  class="page-link"
                  href="#"
                  @click.prevent="page !== '...' && changePage(page - 1)"
                >
                  {{ page }}
                </a>
              </li>

              <li
                class="page-item"
                :class="{ disabled: currentPage === totalPages - 1 }"
              >
                <a
                  class="page-link"
                  href="#"
                  @click.prevent="changePage(currentPage + 1)"
                >
                  <i class="fa fa-angle-right"></i>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>

    <div
      v-if="showModal"
      class="custom-modal-backdrop"
      @click.self="closeModal"
    >
      <div class="custom-modal-dialog animate-pop-in">
        <div class="modal-content border-0 overflow-hidden">
          <div class="modal-header border-bottom-0 pb-0 pt-4 px-4 bg-white">
            <div class="d-flex justify-content-between w-100">
              <div>
                <span
                  class="badge badge-light border text-uppercase font-weight-bold text-primary mb-2"
                >
                  {{ selectedItem.tenDanhMuc }}
                </span>
                <h4 class="modal-title font-weight-bold text-dark">
                  Chi tiết phản ánh & kiến nghị #{{ selectedItem.id }}
                </h4>
              </div>
              <button type="button" class="close-btn" @click="closeModal">
                <i class="fa fa-times"></i>
              </button>
            </div>
          </div>

          <div class="modal-body p-4" v-if="selectedItem">
            <div
              class="bg-light p-3 rounded d-flex flex-wrap align-items-center justify-content-between mb-4"
            >
              <div class="d-flex align-items-center mr-3 mb-2 mb-md-0">
                <div class="avatar-circle bg-white shadow-sm mr-2">
                  <i class="fa fa-user text-primary"></i>
                </div>
                <div>
                  <div class="small text-muted">Người gửi</div>
                  <div class="font-weight-bold text-dark">
                    {{
                      selectedItem.tenNguoiGui === "Người dùng ẩn danh"
                        ? "Ẩn danh"
                        : "Tôi"
                    }}
                  </div>
                </div>
              </div>
              <div class="d-flex align-items-center mr-3 mb-2 mb-md-0">
                <div class="avatar-circle bg-white shadow-sm mr-2">
                  <i class="fa fa-calendar text-info"></i>
                </div>
                <div>
                  <div class="small text-muted">Thời gian</div>
                  <div class="font-weight-bold text-dark">
                    {{ formatDate(selectedItem.ngayTao) }}
                  </div>
                </div>
              </div>
              <div>
                <span
                  :class="[
                    'badge-pill px-3 py-2',
                    getStatusClass(selectedItem.trangThai),
                  ]"
                >
                  {{ getStatusLabel(selectedItem.trangThai) }}
                </span>
              </div>
            </div>

            <div class="form-group mb-4">
              <label
                class="text-uppercase text-muted font-size-xs font-weight-bold"
                >Tiêu đề</label
              >
              <h5 class="text-dark font-weight-bold">
                {{ selectedItem.tieuDe }}
              </h5>
            </div>

            <div class="form-group mb-4">
              <label
                class="text-uppercase text-muted font-size-xs font-weight-bold"
                >Nội dung chi tiết</label
              >
              <div class="content-box">
                {{ selectedItem.noiDung }}
              </div>
            </div>

            <div
              v-if="
                selectedItem.danhSachAnh && selectedItem.danhSachAnh.length > 0
              "
            >
              <label
                class="text-uppercase text-muted font-size-xs font-weight-bold mb-3 d-block"
              >
                <i class="fa fa-paperclip mr-1"></i> Tệp đính kèm
              </label>
              <div class="row">
                <div
                  class="col-md-3 col-6 mb-3"
                  v-for="(img, idx) in selectedItem.danhSachAnh"
                  :key="idx"
                >
                  <div
                    class="attachment-card shadow-sm"
                    @click="showLightbox(selectedItem.danhSachAnh, idx)"
                  >
                    <img :src="img" class="attachment-img" />
                    <div class="attachment-overlay">
                      <i class="fa fa-eye"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="history-section border-top pt-4 mt-4">
              <h6
                class="text-uppercase text-secondary font-weight-bold mb-4"
                style="font-size: 0.75rem; letter-spacing: 1px"
              >
                <i class="fa fa-history mr-2"></i>Tiến trình xử lý
              </h6>

              <div
                v-if="
                  selectedItem.lichSuXuLy && selectedItem.lichSuXuLy.length > 0
                "
                class="activity-stream"
              >
                <div
                  v-for="log in selectedItem.lichSuXuLy"
                  :key="log.id"
                  class="stream-item"
                >
                  <div class="stream-icon">
                    <img
                      :src="log.avatarNguoiThucHien || '/assets/img/user.jpg'"
                      class="avatar-sm rounded-circle shadow-sm"
                    />
                  </div>

                  <div class="stream-content bg-light-card p-3 rounded mb-3">
                    <div
                      class="d-flex justify-content-between align-items-start mb-2"
                    >
                      <div>
                        <span class="font-weight-bold text-dark mr-1">{{
                          log.tenNguoiThucHien
                        }}</span>
                        <span :class="getTextColorClass(log.trangThaiMoi)">
                          {{ getActionLabel(log.trangThaiMoi) }}
                        </span>
                      </div>
                      <small class="text-muted text-nowrap ml-2">
                        <i class="fa fa-clock-o mr-1"></i
                        >{{ formatDate(log.thoiGian) }}
                      </small>
                    </div>

                    <div v-if="log.ghiChu" class="note-box mt-2">
                      <i class="fa fa-quote-left mr-2 opacity-50"></i>
                      <span>{{ log.ghiChu }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div v-else class="text-center py-4 bg-light rounded text-muted">
                <div class="empty-icon-wrapper mb-3">
                  <i class="fa fa-folder-open-o"></i>
                </div>
                <p class="small mb-0">Chưa có hoạt động nào được ghi nhận.</p>
              </div>
            </div>

            <!-- <div class="history-section border-top pt-4 mt-4">
              <h6
                class="text-uppercase text-muted font-weight-bold mb-3 section-title"
              >
                <i class="fa fa-history mr-1"></i> Lịch sử xử lý
              </h6>

              <div
                v-if="
                  selectedItem.lichSuXuLy && selectedItem.lichSuXuLy.length > 0
                "
                class="timeline-container"
              >
                <div
                  v-for="log in selectedItem.lichSuXuLy"
                  :key="log.id"
                  class="timeline-item"
                >
                  <div class="timeline-marker"></div>
                  <div class="timeline-content ml-3">
                    <div class="d-flex align-items-center mb-1">
                      <img
                        :src="log.avatarNguoiThucHien || '/assets/img/user.jpg'"
                        class="avatar-xs rounded-circle mr-2 border"
                      />
                      <span class="font-weight-bold text-dark small">{{
                        log.tenNguoiThucHien
                      }}</span>
                    </div>

                    <div class="log-action mb-1">
                      <span :class="getTextColorClass(log.trangThaiMoi)">
                        {{ getActionLabel(log.trangThaiMoi) }}
                      </span>
                    </div>

                    <div
                      v-if="log.ghiChu"
                      class="mt-1 p-2 rounded small border"
                      :class="
                        log.trangThaiMoi === 'TU_CHOI'
                          ? 'bg-soft-danger border-danger text-danger'
                          : 'bg-light text-muted border-light'
                      "
                    >
                      <i class="fa fa-commenting-o mr-1"></i>
                      <strong>Nội dung:</strong> {{ log.ghiChu }}
                    </div>

                    <div class="text-muted font-size-xs mt-1">
                      <i class="fa fa-clock-o mr-1"></i>
                      {{ formatDate(log.thoiGian) }}
                    </div>
                  </div>
                </div>
              </div>

              <div v-else class="text-center py-3">
                <span class="text-muted small font-italic"
                  >Chưa có lịch sử ghi nhận.</span
                >
              </div>
            </div> -->
          </div>

          <div class="modal-footer bg-light border-top-0 px-4 py-3">
            <div>
              <button
                v-if="selectedItem && selectedItem.trangThai === 'MOI_GUI'"
                type="button"
                class="btn btn-revoke-modal px-3 rounded-pill font-weight-bold shadow-sm"
                @click="handleRevoke(selectedItem)"
              >
                <i class="fa fa-undo mr-1"></i> Thu hồi
              </button>
            </div>
            <button
              type="button"
              class="btn btn-secondary px-4 font-weight-medium rounded-pill"
              @click="closeModal"
            >
              Đóng lại
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, reactive, watch, computed } from "vue";
import baoCaoService from "@/services/gopYKienNghiService";
import VueEasyLightbox from "vue-easy-lightbox";
import Swal from "sweetalert2";
import { useToast } from "vue-toastification";

const toast = useToast();
const showFilterModal = ref(false);
const isFiltering = computed(() => {
  return (
    filters.keyword !== "" ||
    filters.status !== "" ||
    filters.categoryId !== null
  );
});

const applyFilters = () => {
  currentPage.value = 0; // Reset về trang 1
  fetchData();
  showFilterModal.value = false; // Đóng modal
};

const resetFilters = () => {
  filters.keyword = "";
  filters.status = "";
  filters.categoryId = null;
  filters.sort = "ngayTao,desc";
  // Gọi fetch data luôn để làm mới danh sách gốc
  applyFilters();
};

const filters = reactive({
  keyword: "",
  status: "",
  categoryId: null,
  sort: "ngayTao,desc",
});

const listCategories = ref([]); // Danh sách danh mục để lọc
const currentPage = ref(0);
const totalPages = ref(0);
const pageSize = ref(9);

const listBaoCao = ref([]);
const isLoading = ref(true);
const showModal = ref(false);
const selectedItem = ref(null);

const savedViewMode = localStorage.getItem("reportViewMode");
const viewMode = ref(savedViewMode || "grid");
watch(viewMode, (newVal) => {
  localStorage.setItem("reportViewMode", newVal);
});

// Lightbox props
const lightboxVisible = ref(false);
const lightboxImgs = ref([]);
const lightboxIndex = ref(0);

const fetchData = async () => {
  isLoading.value = true;
  try {
    // Gọi API lấy danh mục (chỉ gọi 1 lần nếu chưa có)
    if (listCategories.value.length === 0) {
      const catRes = await baoCaoService.getDanhMucActive();
      listCategories.value = catRes.data;
    }

    // Gọi API lấy danh sách phản ánh & kiến nghị có tham số
    // API: /cua-toi?page=0&size=9&sort=...&tuKhoa=...&trangThai=...&danhMucId=...
    const params = {
      page: currentPage.value,
      size: pageSize.value,
      sort: filters.sort,
      tuKhoa: filters.keyword || null,
      trangThai: filters.status || null,
      danhMucId: filters.categoryId || null,
    };

    const res = await baoCaoService.getMyReports(params); // Sửa service nhận params

    // Xử lý response phân trang từ Spring Boot
    if (res.data && res.data.content) {
      listBaoCao.value = res.data.content;
      totalPages.value = res.data.totalPages;
    } else {
      // Fallback nếu API chưa hỗ trợ phân trang (trả về list thuần)
      listBaoCao.value = res.data;
    }
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};

const handleRevoke = async (item) => {
  // 1. Xác nhận hành động
  const result = await Swal.fire({
    title: "Thu hồi phản ánh & kiến nghị?",
    text: "Phản ánh & kiến nghị này sẽ bị xóa và không thể khôi phục. Bạn chắc chắn chứ?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33", // Màu đỏ cảnh báo
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Đúng, thu hồi ngay",
    cancelButtonText: "Hủy bỏ",
  });

  if (result.isConfirmed) {
    try {
      // 2. Gọi API thu hồi
      await baoCaoService.revokeReport(item.id);

      toast.success("Đã thu hồi thành công!");

      // 3. Cập nhật lại giao diện
      fetchData(); // Tải lại danh sách

      // Nếu đang mở modal của item đó thì đóng lại
      if (
        showModal.value &&
        selectedItem.value &&
        selectedItem.value.id === item.id
      ) {
        closeModal();
      }
    } catch (error) {
      console.error(error);
      toast.error(
        error.response?.data?.message ||
          "Không thể thu hồi phản ánh & kiến nghị này."
      );
    }
  }
};

const handleFilterChange = () => {
  currentPage.value = 0; // Reset về trang đầu
  fetchData();
};

const changePage = (page) => {
  if (page >= 0 && page < totalPages.value) {
    currentPage.value = page;
    fetchData();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
};

// --- Logic tính toán số trang hiển thị (Pagination UI) ---
const visiblePages = computed(() => {
  const delta = 2;
  const range = [];
  for (
    let i = Math.max(2, currentPage.value - delta);
    i <= Math.min(totalPages.value - 1, currentPage.value + delta);
    i++
  ) {
    range.push(i);
  }
  if (currentPage.value - delta > 2) range.unshift("...");
  if (currentPage.value + delta < totalPages.value - 1) range.push("...");
  range.unshift(1);
  if (totalPages.value !== 1) range.push(totalPages.value);
  return range;
});

const openDetail = (item) => {
  selectedItem.value = item;
  showModal.value = true;
};

const closeModal = () => {
  showModal.value = false;
  setTimeout(() => {
    selectedItem.value = null;
  }, 300); // Wait for animation
};

const showLightbox = (imgs, idx) => {
  lightboxImgs.value = imgs;
  lightboxIndex.value = idx;
  lightboxVisible.value = true;
};
const onHideLightbox = () => {
  lightboxVisible.value = false;
};

const formatDate = (dateString) => {
  if (!dateString) return "";
  return new Date(dateString).toLocaleString("vi-VN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const getStatusLabel = (status) => {
  const map = {
    MOI_GUI: "Mới gửi",
    DA_XEM: "Đã xem",
    DANG_XU_LY: "Đang xử lý",
    DA_GIAI_QUYET: "Hoàn thành",
    TU_CHOI: "Từ chối",
  };
  return map[status] || status;
};

const getStatusClass = (status) => {
  const map = {
    MOI_GUI: "pill-primary",
    DA_XEM: "pill-info",
    DANG_XU_LY: "pill-warning",
    DA_GIAI_QUYET: "pill-success",
    TU_CHOI: "pill-danger",
  };
  return map[status] || "pill-secondary";
};

const getActionLabel = (status) => {
  const map = {
    MOI_GUI: "Đã gửi",
    DA_XEM: "Đã xem báo cáo",
    DANG_XU_LY: "Đã tiếp nhận",
    DA_GIAI_QUYET: "Đã hoàn thành xử lý",
    TU_CHOI: "Đã từ chối yêu cầu",
  };
  return map[status] || "Cập nhật trạng thái";
};

// Hàm lấy màu chữ
const getTextColorClass = (status) => {
  const map = {
    MOI_GUI: "text-primary",
    DA_XEM: "text-info",
    DANG_XU_LY: "text-warning",
    DA_GIAI_QUYET: "text-success",
    TU_CHOI: "text-danger",
  };
  return map[status] || "text-secondary";
};

// Helper for dot/icon color
const getStatusColorClass = (status, isBg = false) => {
  const map = {
    MOI_GUI: "primary",
    DA_XEM: "info",
    DANG_XU_LY: "warning",
    DA_GIAI_QUYET: "success",
    TU_CHOI: "danger",
  };
  const color = map[status] || "secondary";
  return isBg ? `bg-soft-${color} text-${color}` : `bg-${color}`;
};

onMounted(() => fetchData());
</script>

<style scoped>
/* --- Page Layout --- */
.page-wrapper {
  min-height: 100vh;
  padding-bottom: 40px;
}

/* --- View Switcher --- */
.btn-view {
  border: 1px solid transparent;
  color: #999;
  padding: 8px 14px;
  background: white;
  transition: all 0.2s;
}
.btn-view:hover {
  color: #333;
  background: #f8f9fa;
}
.btn-view.active {
  color: #4a6cf7;
  background: #eef2ff;
  font-weight: bold;
}
.btn-add {
  border-radius: 50px;
  padding: 8px 24px;
  font-weight: 600;
}

/* --- Empty State --- */
.empty-state {
  background: white;
  border-radius: 12px;
  padding: 60px 20px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.03);
}
.empty-icon-wrapper {
  width: 80px;
  height: 80px;
  background: #f0f2f5;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  font-size: 32px;
  color: #999;
}

/* --- Modern Card Style (Grid View) --- */
.modern-card {
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;
  cursor: pointer;
  background: #fff;
  overflow: hidden;
}
.modern-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
}
.text-truncate-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.category-tag {
  background-color: #f3f6f9;
  color: #5e6278;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
}
.status-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
}

/* --- List View Style --- */
.list-group-item {
  border: none;
  border-bottom: 1px solid #f0f2f5;
  transition: background-color 0.2s;
}
.list-group-item:last-child {
  border-bottom: none;
}
.list-group-item:hover {
  background-color: #fbfbfb;
}
.list-icon-shape {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  flex-shrink: 0;
}

/* --- Image Grid Preview --- */
.img-preview-grid {
  display: flex;
  gap: 4px;
}
.img-thumb,
.img-more {
  width: 40px;
  height: 40px;
  border-radius: 6px;
  overflow: hidden;
}
.img-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.img-more {
  background: #e9ecef;
  color: #6c757d;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: bold;
}

/* --- Typography & Utils --- */
.font-size-xs {
  font-size: 0.75rem;
}
.font-size-sm {
  font-size: 0.875rem;
}
.avatar-circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #f3f6f9;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #7e8299;
}

/* --- Status Pills (Shared) --- */
.badge-pill,
.badge-pill-sm {
  border-radius: 50px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.badge-pill {
  padding: 6px 12px;
  font-size: 0.75rem;
}
.badge-pill-sm {
  padding: 4px 8px;
  font-size: 0.7rem;
}

.pill-primary {
  background: #e1f0ff;
  color: #3699ff;
}
.pill-info {
  background: #e0f7fa;
  color: #00bcd4;
}
.pill-warning {
  background: #fff4de;
  color: #ffa800;
}
.pill-success {
  background: #e8fff3;
  color: #1bc5bd;
}
.pill-danger {
  background: #ffe2e5;
  color: #f64e60;
}
.pill-secondary {
  background: #f3f6f9;
  color: #7e8299;
}

/* Background Soft Colors for Icons */
.bg-soft-primary {
  background: #e1f0ff;
}
.bg-soft-info {
  background: #e0f7fa;
}
.bg-soft-warning {
  background: #fff4de;
}
.bg-soft-success {
  background: #e8fff3;
}
.bg-soft-danger {
  background: #ffe2e5;
}
.bg-soft-secondary {
  background: #f3f6f9;
}

/* --- Custom Modal --- */
.custom-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.custom-modal-dialog {
  width: 100%;
  max-width: 700px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}
.modal-body {
  overflow-y: auto;
}
.close-btn {
  background: #f3f6f9;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  color: #333;
  transition: all 0.2s;
}
.close-btn:hover {
  background: #e4e6ef;
}

.content-box {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  color: #3f4254;
  line-height: 1.6;
  white-space: pre-wrap;
}

/* Attachment Styles */
.attachment-card {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  height: 100px;
}
.attachment-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;
}
.attachment-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s;
}
.attachment-card:hover .attachment-img {
  transform: scale(1.05);
}
.attachment-card:hover .attachment-overlay {
  opacity: 1;
}
.attachment-overlay i {
  color: white;
  font-size: 1.5rem;
}

/* Transitions */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.animate-pop-in {
  animation: popIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
@keyframes popIn {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

/* Nút thu hồi nhỏ trong Grid */
.btn-xs {
  padding: 2px 8px;
  font-size: 0.75rem;
  line-height: 1.5;
  border-radius: 4px;
}
.bg-soft-danger {
  background-color: #ffe2e5;
  color: #f64e60;
}
.bg-soft-danger:hover {
  background-color: #f64e60;
  color: white;
}

/* Hiệu ứng hover cho nút trong List */
.btn-hover-danger:hover {
  background-color: #ffe2e5;
  border-radius: 4px;
}

.btn-revoke-modal {
  background-color: #fff; /* Nền trắng mặc định */
  color: #dc3545; /* Chữ đỏ */
  border: 1px solid #dc3545; /* Viền đỏ */
  transition: all 0.3s ease;
}

.btn-revoke-modal:hover {
  background-color: #dc3545 !important; /* Hover: Nền đỏ */
  color: #fff !important; /* Hover: Chữ trắng */
  border-color: #dc3545;
  transform: translateY(-2px); /* Hiệu ứng nảy nhẹ */
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3) !important;
}

.activity-stream {
  position: relative;
  padding-left: 24px; /* Khoảng cách cho đường kẻ dọc */
  border-left: 2px solid #eef2f7; /* Đường kẻ dọc mờ */
  margin-left: 12px;
}

.stream-item {
  position: relative;
  padding-bottom: 8px;
}

/* Icon Avatar nằm trên đường kẻ */
.stream-icon {
  position: absolute;
  left: -37px; /* Căn chỉnh avatar vào giữa đường kẻ */
  top: 0;
  width: 28px;
  height: 28px;
  background: #fff;
  padding: 2px; /* Viền trắng quanh avatar */
}
.stream-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Khối nội dung */
.stream-content {
  background-color: #f8f9fa; /* Nền xám rất nhẹ */
  border: 1px solid #f1f1f1;
  transition: all 0.2s;
  position: relative;
}
.stream-content:hover {
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  border-color: #e1e1e1;
}

/* Mũi tên trỏ vào avatar (Optional - tạo cảm giác hội thoại) */
.stream-content::before {
  content: "";
  position: absolute;
  left: -6px;
  top: 10px;
  width: 10px;
  height: 10px;
  background-color: inherit; /* Giống màu nền cha */
  transform: rotate(45deg);
  border-left: 1px solid #f1f1f1; /* Khớp border */
  border-bottom: 1px solid #f1f1f1;
}
.stream-content:hover::before {
  background-color: #fff;
  border-color: #e1e1e1;
}

/* Hộp hiển thị đổi trạng thái */
.status-change-box {
  background: #fff;
  padding: 6px 12px;
  border-radius: 6px;
  border: 1px dashed #d1d5db;
  display: inline-block;
  font-size: 0.85rem;
}

/* Ghi chú */
.note-box {
  font-style: italic;
  color: #913c39;
  font-size: 0.9rem;
  padding-top: 4px;
}

/* Màu text trạng thái */
.text-primary {
  color: #007bff !important;
}
.text-warning {
  color: #ffc107 !important;
}
.text-success {
  color: #28a745 !important;
}
.text-danger {
  color: #dc3545 !important;
}
.text-secondary {
  color: #6c757d !important;
}
.empty-icon-wrapper {
  width: 80px;
  height: 80px;
  background: #f0f2f5;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  font-size: 32px;
  color: #999;
}
</style>
